import { z } from "zod";

import { UserBase } from "@/data/users";

export const TimeReportWorker = UserBase.extend({
  guid: z.string(),
  profileId: z.number(),
}).passthrough();

export type TimeReportWorker = z.infer<typeof TimeReportWorker>;
